import React, { useState } from "react";
import PrivateCouncilTheMomentArrive from "./ReusableComponent/PrivateCouncilTheMomentArrive";
import PrivateCouncilWhatThisIsNot from "./ReusableComponent/PrivateCouncilWhatThisIsNot";
import PrivateCouncilWhoSheeks from "./ReusableComponent/PrivateCouncilWhoSheeks";
import PrivateCouncilTestimonials from "./ReusableComponent/PrivateCouncilTestimonials";
import PrivateCouncilHero from "./ReusableComponent/PrivateCouncilHero";
import PrivateCouncilThreshold from "./ReusableComponent/PrivateCouncilThreshold";
import PrivateCouncilInside from "./ReusableComponent/PrivateCouncilInside";
import PrivateCouncilWhyBhupendra from "./ReusableComponent/PrivateCouncilWhyBhupendra";
import PrivateCouncilConditionEngagement from "./ReusableComponent/PrivateCouncilConditionEngagement";
import HowEngagementOccurs from "./ReusableComponent/HowEngagementOccurs";
import FinalWordSection from "./ReusableComponent/FinalWordSection";
import PortfolioCollapse from "./ReusableComponent/PortfolioCollapse";
const PrivateCouncilNewPage = () => {
    const [formData, setFormData] = useState({
        councilName: "",
        description: "",
        startDate: "",
        endDate: "",
        status: "Active",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitted Data:", formData);
    };

    return (<>
        <PrivateCouncilHero />
        <PrivateCouncilThreshold />
        <PortfolioCollapse/>
        <PrivateCouncilWhoSheeks />
        <PrivateCouncilTheMomentArrive />
        <PrivateCouncilTestimonials />
        <PrivateCouncilInside />
        <PrivateCouncilWhatThisIsNot />
        <PrivateCouncilWhyBhupendra />
        <PrivateCouncilConditionEngagement />
        <HowEngagementOccurs />
        <FinalWordSection/>
    </>
    );
};

export default PrivateCouncilNewPage;